module.exports = __webpack_public_path__ + "static/media/sebi-stringent-sustainability-reporting.d0882c4b.webp";